import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useUser } from './UserContext'; // Import the user context
import LoginPopup from './LoginPopup';
import './css/Header.css';
import Searchbar2 from './SearchBar2';

function Header() {
  const { user, logout } = useUser(); // Access user and logout from context
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State for dropdown visibility

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleOutsideClick = (event) => {
    if (!event.target.closest('.profile-container')) {
      setIsDropdownOpen(false);
    }
  };

  React.useEffect(() => {
    if (isDropdownOpen) {
      document.addEventListener('click', handleOutsideClick);
    } else {
      document.removeEventListener('click', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [isDropdownOpen]);

  return (
    <div className="header2">
      <div className="logo">
        <Link to="/">službomat</Link>
        </div>
      
      <Searchbar2/>
      
      <div className="login">
        {user ? (
          <div className="profile-container">
            <div className="profile" onClick={toggleDropdown}>
              {user.displayName || user.email} &nbsp;
              {" "}
              <i className={`fas ${isDropdownOpen ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
            </div>
            <div className={`dropdown-menu ${isDropdownOpen ? 'open' : ''}`}>
              <ul>
                {/* <li>
                  <Link to="/calendar">Kalendár</Link>
                </li> */}
                <li>
                  <Link to="/favorites">Obľúbené</Link>
                </li>
                <li>
                  <Link to="/seo">Pre Firmy</Link>
                </li>
                <li>
                  <button className='logout' onClick={logout}>Odhlásiť</button>
                </li>
              </ul>
            </div>
          </div>
        ) : (
          <LoginPopup />
        )}
      </div>
    </div>
  );
}

export default Header;
